import { FlockProfileDetail } from './flock-profile-detail/flock-profile-detail';

export default FlockProfileDetail;
export * from './flock-profile-detail/flock-profile-detail';
export * from './flock-profiles';

